<template>
  <section :class="{ 'mb-3': margin }">
    <v-layout v-if="title.length > 0" class="blue mb-2 pa-2 lighten-4">
      <h3>
        {{ title }}
      </h3>
      <v-tooltip v-if="tipMessage.length > 0" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            outline
            fab
            small
            class="back-button"
            v-on="on"
            @click="$emit('back')"
          >
            <v-icon>undo</v-icon>
          </v-btn>
        </template>
        <span>{{ tipMessage }}</span>
      </v-tooltip>
    </v-layout>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'CampaignModalPageConfirmSection',
  props: {
    title: {
      type: String,
      default: '',
    },
    margin: {
      type: Boolean,
      default: false,
    },
    tipMessage: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.back-button {
  height: 20px;
  width: 20px;
  margin: 3px 0 0 12px;
}
</style>
